import React from 'react';
import { Helmet } from 'react-helmet-async';

import useAlerts from '../../../../hooks/order/useAlerts';
import Order from '../../../../models/order/Order';
import { modelOf } from '../../../../prop-types';
import CustomCol from '../../../bootstrap/CustomCol';
import OrderTrackingLink from '../OrderTrackingLink';

const CheckoutHtmlWidget = ({ currentOrder }) => {
  const { commonAlerts } = currentOrder;

  const { renderGeneralAlerts } = useAlerts({
    generalAlerts: commonAlerts.general,
  });

  const renderHtmlWidget = () => {
    const widgetHtml = currentOrder.html_widget;
    const doc = document.implementation.createHTMLDocument('');
    doc.body.innerHTML = widgetHtml;

    return (
      <>
        <Helmet>
          {[].map.call(doc.getElementsByTagName('script'), (el, index) => (
            <script key={index}>{el.textContent}</script>
          ))}
        </Helmet>
        <div dangerouslySetInnerHTML={{ __html: widgetHtml }} />
      </>
    );
  };

  return (
    <CustomCol xs={12} md={10} xxl={7}>
      {renderGeneralAlerts()}
      <OrderTrackingLink currentOrder={currentOrder} />
      {renderHtmlWidget()}
    </CustomCol>
  );
};

CheckoutHtmlWidget.propTypes = {
  currentOrder: modelOf(Order).isRequired,
};

export default CheckoutHtmlWidget;
